import * as Yup from "yup";

const phoneRegExp = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm;

export const clientDetailSchema = Yup.object().shape({
  cName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Name must contain letters only")
    .required("Customer Name is required"),
  phoneNumber: Yup.string()
    .required("Phone number is required")
    .matches(phoneRegExp, "Phone number is not valid"),
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email address"),
});

export const existClientDetailSchema = Yup.object().shape({
  accountPhoneNumber: Yup.string()
    .required("Account phone number is required")
    .matches(phoneRegExp, "Account phone number is not valid"),
});

export const clientAddressSchema = (schedulerData) => {
  const zipRestriction = schedulerData?.zipRestriction;
  const zipCodes = schedulerData?.zipCodes;
  const zipCodesList = zipCodeListToString(zipCodes);

  return Yup.object().shape({
    streetAddress: Yup.string().required("Street address is required"),
    // unitNumber: Yup.string().required("Unit number is required"),
    city: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "city must contain letters only")
      .required("city is required"),
    state: Yup.string().required("state is required"),
    zipCode: Yup.string()
      .matches(/^[0-9]{5}$/, "Zip code must be max 5 digits")
      .required("Zip code is required")
      .test(
        "is-valid-zipCode",
        "Sorry, we do not serve that area. Please call if you feel this is in error.",
        (value) => {
          if (!value || !zipRestriction) return true; // Allow empty values
          return zipCodesList.includes(value);
        }
      ),
    // isOwner: Yup.bool().oneOf([true], "You need to accept own residence"),
  });
};

const zipCodeListToString = (zipCodeList) => {
  const stringList = zipCodeList.split(",").map((zipcode) => {
    return String(zipcode);
  }); // Split the string and convert to number
  return stringList;
};
